exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SaveButton-saveBtn-UDP7K {\n\tline-height: 43px;\n}\nspan {\n\t-webkit-text-decoration: none;\n\ttext-decoration: none;\n}\nspan:hover, span:active, span:focus, span:visited {\n\t-webkit-text-decoration: none !important;\n\ttext-decoration: none !important;\n}\n", ""]);

// exports
exports.locals = {
	"saveBtn": "SaveButton-saveBtn-UDP7K"
};